<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('mentor_time_off_request_form')"
                        :isFilter="false"/>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('mentor_time_off_request_form')"
                              :isFilter="false"/>
            </template>
            <b-container fluid="md">
                <b-row class="justify-content-center">
                    <b-col cols="12" md="8">
                        <b-card class="mt-4">
                            <ValidationObserver ref="formObserver">
                                <b-form @submit.prevent="onSubmit">
                                    <b-row>
                                        <b-col cols="12">
                                                <b-form-group
                                                    id="input-group-name"
                                                    :label="$t('full_name')"
                                                    label-for="input-name"
                                                >
                                                    <b-form-input
                                                        v-model="fullName"
                                                        id="input-name"
                                                        type="text"
                                                        readonly
                                                    ></b-form-input>
                                                </b-form-group>
                                        </b-col>

                                        <b-col cols="12">
                                            <b-form-group
                                                id="input-group-name"
                                                :label="$t('student_id')"
                                                label-for="input-name"
                                            >
                                                <b-form-input
                                                    id="input-name"
                                                    type="text"
                                                    v-model="form.student_number"
                                                    readonly
                                                ></b-form-input>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12">
                                            <ValidationProvider name="selected_sessions"
                                                                rules="required"
                                                                v-slot="{ valid, errors }">
                                                <b-form-group :label="$t('Time Off Module')">
                                                    <multi-selectbox
                                                        v-model="selected_sessions"
                                                        :multiple="false"
                                                        :options="options"
                                                        :validate-error="errors[0]"
                                                    ></multi-selectbox>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col cols="12">
                                            <ValidationProvider name="selected_sessions"
                                                                rules="required"
                                                                v-slot="{ valid, errors }">
                                                    <b-form-checkbox
                                                        id="checkbox-1"
                                                        v-model="form.status"
                                                        name="checkbox-1"
                                                        value="accepted"
                                                        :unchecked-value="null"
                                                    >
                                                        I have read and understood all the terms and requirements in the student handbook regarding
                                                        time off. By signing below, I certify that I agree with those terms.
                                                    </b-form-checkbox>
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>

                                            </ValidationProvider>
                                            </b-col>
                                        <b-col cols="12" class="text-center mt-3">
                                            <LoadingButton
                                                :loading="isLoading"
                                                text="Save"
                                                @click="onSubmit"/>
                                        </b-col>
                                    </b-row>
                                </b-form>
                            </ValidationObserver>
                        </b-card>
                    </b-col>
                </b-row>
            </b-container>
        </app-layout>
    </div>
</template>

<script>
// Template
import AppLayout from "@/layouts/AppLayout.vue";
import Header from "@/layouts/AppLayout/Header.vue";
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile.vue";
import LoadingButton from "@/components/elements/LoadingButton.vue";
// Other
import {ValidationProvider, ValidationObserver} from "vee-validate"
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox.vue";
import MentoraTimeOffRequestFormServices from "@/services/MentoraTimeOffRequestFormServices";

export default {
    components: {
        MultiSelectbox,
        AppLayout,
        Header,
        LoadingButton,
        HeaderMobile,
        ValidationProvider,
        ValidationObserver,
    },
    data() {
        return {
            isLoading: false,
            form: {},
            selected_sessions:[]
        }
    },

    metaInfo() {
        return {
            title: this.$t('mentor_time_off_request_form')
        }
    },
    created() {
        this.getData();
    },
    computed:{
      fullName(){
          if (!this.form){
              return ''
          }
          return (this.form?.name??'') + " " + (this.form?.surname??'')
      },
      options(){
          if (this.form?.module_dates){
              return  this.form.module_dates.map((item) => {
                  return {
                      text: item.name,
                      value: item.id
                  }
              })
          }else {
              return []
          }
      }
    },
    methods: {
        async getData(){
            try {
                const res = await MentoraTimeOffRequestFormServices.getData()
                this.form=res.data.data
            }catch (error){
                this.showErrors(error)
            }
        },
        async onSubmit() {
            const isValid = await this.$refs.formObserver.validate();
            if (isValid) {
                this.isLoading = true
                const data ={
                    selected_sessions:this.selected_sessions,
                }
                try {
                    const res = await MentoraTimeOffRequestFormServices.save(data)
                    this.$toast.success(this.$t('Form submitted successfully.'))
                    this.$router.push('/my-mentora-requests/1')
                }catch (error) {
                    this.showErrors(error,this.$refs.formObserver)
                }finally {
                    this.isLoading = false
                }
            }
        }
    },
};
</script>

<style scoped>
.card {
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

</style>
